/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { LivenessSceneEnum, LivenessSceneEnumH5Url, LivenessSceneEnumUrl } from '@/enums/liveness-param';
import { NativeVo } from '@/vo/Native';

const redirectUrl = (
  extraParams: NativeVo.LivenessParam,
  LivenessSceneUrl: string,
) => Object.assign(extraParams, {
  ...extraParams,
  // 唤起活体的时候，有跳转地址 用跳转地址，没有的时候，走配置
  redirectUrl: extraParams.redirectUrl ? extraParams.redirectUrl : LivenessSceneUrl,
});

export const getAlipayMiniUrl = (extraParams: NativeVo.LivenessParam) => {
  switch (extraParams.scene) {
    case LivenessSceneEnum.Authority:
      redirectUrl(extraParams, LivenessSceneEnumUrl.Authority);
      break;
    case LivenessSceneEnum.Apply:
      redirectUrl(extraParams, LivenessSceneEnumUrl.Apply);
      break;
    case LivenessSceneEnum.ChangePassword:
      redirectUrl(extraParams, LivenessSceneEnumUrl.ChangePassword);
      break;
    case LivenessSceneEnum.SetPassword:
      redirectUrl(extraParams, LivenessSceneEnumUrl.SetPassword);
      break;
    case LivenessSceneEnum.Logout:
      redirectUrl(extraParams, LivenessSceneEnumUrl.Logout);
      break;
    default:
      redirectUrl(extraParams, LivenessSceneEnumUrl.Logout);
      break;
  }
  return extraParams;
};

/** 微信小程序活体设置成功后的兜底回跳页面 */
export const getWechatMiniUrl = (
  extraParams: NativeVo.LivenessParam,
) => {
  switch (extraParams.scene) {
    case LivenessSceneEnum.Apply:
      redirectUrl(extraParams, LivenessSceneEnumH5Url.Apply);
      break;
    case LivenessSceneEnum.ChangePassword:
      redirectUrl(extraParams, LivenessSceneEnumH5Url.ChangePassword);
      break;
    case LivenessSceneEnum.SetPassword:
      redirectUrl(extraParams, LivenessSceneEnumH5Url.SetPassword);
      break;
    default:
      /** 兜底逻辑：其他场景若未设置回跳页面，则默认回跳至当前页面 */
      redirectUrl(extraParams, window.location.href);
      break;
  }

  return extraParams;
};

export const getH5Url = (extraParams: NativeVo.LivenessParam) => {
  switch (extraParams.scene) {
    case LivenessSceneEnum.Authority:
      redirectUrl(extraParams, LivenessSceneEnumH5Url.Authority);
      break;
    case LivenessSceneEnum.Apply:
      redirectUrl(extraParams, LivenessSceneEnumH5Url.Apply);
      break;
    case LivenessSceneEnum.ChangePassword:
      redirectUrl(extraParams, LivenessSceneEnumH5Url.ChangePassword);
      break;
    case LivenessSceneEnum.SetPassword:
      redirectUrl(extraParams, LivenessSceneEnumH5Url.SetPassword);
      break;
    default:
      break;
  }
  return extraParams;
};
